import type { Driver } from '@multirx/shared/types/driver.js';
import type { RaceHistorySummary } from '@multirx/shared/types/raceHistory.js';
import type { DriverSeasonProfile } from '@multirx/shared/game/driverPalmares.js';
import type { UserRole } from '@multirx/shared/types/user.js';
import { DIVISIONS } from '@multirx/shared/types/division.js';

export function canEditDriverStats(role: UserRole | null | undefined): boolean {
  return role === 'admin' || role === 'moderator';
}

export function divisionLabel(division: number | undefined): string {
  if (division == null) return '—';
  return DIVISIONS.find((d) => d.id === division)?.shortLabel ?? `D${division}`;
}

export function formatRaceDate(iso: string | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function raceInvolvesDriver(race: RaceHistorySummary, driver: Driver): boolean {
  const full = `${driver.firstName} ${driver.lastName}`.trim().toLowerCase();
  if (race.winnerDriverName?.trim().toLowerCase() === full) return true;
  return (race.participants ?? []).some((p) => p.driverName.trim().toLowerCase() === full);
}

/** Pas d’onglet palmarès si aucun titre ni stats saison utiles. */
export function isPalmaresEmpty(profile: DriverSeasonProfile | null): boolean {
  if (profile == null) return true;
  if (profile.titles.length > 0) return false;
  const s = profile.season;
  return s.championshipPoints <= 0 && s.finalsWon <= 0 && s.podiums <= 0 && s.rank <= 0;
}
